import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { BsArrowsFullscreen } from "react-icons/bs";

function JournalDetail({ entry, fetchEntryById }) {

	const { id } = useParams();
	const [localEntry, setLocalEntry] = useState(null);
    const [htmlContent, setHtmlContent] = useState('');

	useEffect(() => {
		if (id) {
			let entry = fetchEntryById(id);
			setLocalEntry(entry);
		}
	}, [id]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (localEntry){
            loadHTMLFile();
        }
    }, [localEntry]); // eslint-disable-line react-hooks/exhaustive-deps

    const loadHTMLFile = async () => {
        try {
            const htmlFile = await import(`../posts/${localEntry.id}.js`)
            setHtmlContent(htmlFile.default);
          } catch (error) {
            console.error('Error finding HTML file:', error);
            setHtmlContent('<p>File not found.</p>');
          }
      };

	useEffect(() => {
		if (entry){
			setLocalEntry(entry);
        }
	}, [entry]);
	
    const handleFullScreenClick = () => {
        if (entry) {
            window.open(`/journal/${entry.id}`, '_self');
        }
    }

    if (!localEntry) return <div>Select an entry to view details.</div>;
    return (
        <div className={`journal-detail ${id ? 'overflow-container' : 'overflow-hidden'}` }  >
            <br></br>
            { !id && <div style={{ float: "right", marginRight: "1rem", cursor: "pointer" }}>
                <BsArrowsFullscreen onClick={handleFullScreenClick}/>
            </div>}
            <div dangerouslySetInnerHTML={{ __html: htmlContent.contents }} />
        </div>
    );
}

// const getBigPicture = (entry) => {
//     return entry.image.replace("{width}", 1200).replace("{height}", 500);
// };

export default JournalDetail;
